import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import { StoreProvider } from './store/useStore'
import App from './App';
import { getTheme } from './theme';
import { ThemeModeProvider, useThemeMode } from './contexts/ThemeContext';
import * as serviceWorker from './serviceWorker';
import './DocViewer.css'

// Wrapper component to access theme context
function ThemedApp() {
  const { mode } = useThemeMode();
  const theme = React.useMemo(() => getTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <StoreProvider >
        <App />
      </StoreProvider>
    </ThemeProvider>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <ThemeModeProvider>
      <ThemedApp />
    </ThemeModeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
  onUpdate: registration => {
    const isConfirmed = window.confirm(
      'A new version of the app is available. Would you like to reload to get the latest version?'
    );
    if (isConfirmed && registration && registration.waiting) {
      // Tell the waiting service worker to skip waiting and become active
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      // Don't reload immediately - let the controllerchange event handle it
      // The reload will happen automatically when the new SW takes control
    }
  },
  onSuccess: registration => {
    console.log('App is ready for offline use and will cache resources for faster loading.');
  }
});
